import React from 'react';
import classnames from 'classnames';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
import { getThumbGlobalClassNames } from '../../helpers';
const CommissionThumbHtmlView = ({ deviation, width, height })=>/*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-header"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "daeditor-freeform-title"
    }, getDeviationTitle(deviation))));
CommissionThumbHtmlView.displayName = 'CommissionThumbHtmlView';
export default CommissionThumbHtmlView;
